// Capital gains tax rates used by the tax calculators.
//
// Rates reflect the framework introduced in Budget 2024 (unchanged by Budget
// 2025/2026 as of this writing). This is indicative only — always confirm
// current rates with a tax professional before relying on these numbers.

export const AS_OF = "FY2025-26 (AY2026-27)";

export const EQUITY_STCG_RATE = 0.2;
export const EQUITY_LTCG_RATE = 0.125;
export const EQUITY_LTCG_EXEMPTION_PER_FY = 1_25_000;

// Debt mutual funds purchased on/after this date lose indexation and LTCG
// treatment entirely — gains are taxed at slab rate regardless of holding period.
export const DEBT_FUND_LTCG_CUTOFF_DATE = "2023-04-01";

export const OTHER_ASSET_LTCG_RATE = 0.125;
export const OTHER_ASSET_LTCG_HOLDING_MONTHS = 24;

// Property acquired before this date retains the option of 20% LTCG with
// indexation instead of the flat 12.5% no-indexation rate.
export const PROPERTY_INDEXATION_OPTION_CUTOFF_DATE = "2024-07-23";
export const PROPERTY_LTCG_WITH_INDEXATION_RATE = 0.2;

export const TAX_NOTICE =
  "Indicative only — capital gains tax rules change with every Budget. " +
  `Rates shown are as of ${AS_OF}. Confirm current rates with a tax professional ` +
  "before making a decision.";
